import { memo } from 'react';
import { useNavigate } from 'react-router-dom';

import inmarketLogo from '../../../images/inmarket-logo.png';
import logo from '../../../images/Lci-text-right.png';
import attributionIcon from '../../../images/svg/icon_attribution.svg';

import NavLinks from './NavLinks';
import './styles/navbar.scss';
import { Box, Stack } from '@mui/material';

export type NavbarProps = {
  showDownload?: boolean;
  style?: React.CSSProperties;
  onHelpModalToggle: () => void;
};

const Navbar = memo((props: NavbarProps) => {
  const navigate = useNavigate();

  return (
    <Box
      id="topmost"
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-start',
        width: '100%',
        paddingX: '1rem',
        paddingY: '0.5rem',
        zIndex: 1000,
      }}
      style={props.style}
    >
      <Stack
        className="nav-title-logo"
        onClick={() => void navigate('/')}
        direction="row"
        alignItems="center"
        sx={{
          boxSizing: 'border-box',
          marginRight: 'auto',
        }}
      >
        <img src={inmarketLogo} alt="inmarket" />
        <img
          src={attributionIcon}
          className="attribution-logo"
          alt="attribution"
        />
        <span>Attribution</span>
      </Stack>
      <Box className="nd-nav" sx={{ display: 'flex' }}>
        <img
          src={logo}
          className="tenant-logo d-inline-block align-top"
          alt="advertiser"
        />
      </Box>
      <Box id="basic-navbar-nav" sx={{ paddingX: '1rem', paddingY: '0.5rem' }}>
        <NavLinks onHelpModalToggle={props.onHelpModalToggle} />
      </Box>
    </Box>
  );
});

Navbar.displayName = 'Navbar';

export default Navbar;
